import MuiAutocomplete from "@mui/material/Autocomplete"
import { StyledPaper, StyledTextField } from "./styles"
import ArrowDownIcon from "@/assets/icons/ArrowDownIcon"

export interface AutocompleteOption<T> {
   label: string
   value: T
}

interface AutocompleteProps<T> {
   options: AutocompleteOption<T>[]
   value: T
   onChange: (value: T) => void
}

const Autocomplete = <T,>({
   options,
   value,
   onChange,
}: AutocompleteProps<T>) => {
   const selectedOption =
      options.find((option) => option.value === value) ?? null

   const handleChange = (option: AutocompleteOption<T> | null) => {
      if (!option) return
      onChange(option.value)
   }

   return (
      <MuiAutocomplete<AutocompleteOption<T>, false, boolean>
         options={options}
         value={selectedOption}
         onChange={(_event, option) => handleChange(option)}
         isOptionEqualToValue={(option, selected) =>
            option.value === selected.value
         }
         disableClearable
         fullWidth
         noOptionsText="No results"
         popupIcon={
            <ArrowDownIcon
               name="arrowDown"
               width="8px"
               height="8px"
            />
         }
         slots={{ paper: StyledPaper }}
         renderInput={(params) => (
            <StyledTextField
               {...params}
               variant="standard"
               slotProps={{
                  input: { ...params.InputProps, disableUnderline: true },
               }}
            />
         )}
      />
   )
}

export default Autocomplete
